import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import flatpickr from 'flatpickr';
import { Italian } from 'flatpickr/dist/l10n/it';

flatpickr.localize(Italian);

bootstrapApplication(AppComponent, appConfig).catch(err => console.error(err));
